function debounce(fn, delay) {
  let timer;

  function cancel() {
    if (timer !== undefined) {
      clearTimeout(timer);
    }
  }

  function debounced(...args) {
    cancel();
    timer = setTimeout(() => fn(...args), delay);
  }

  debounced.cancel = cancel;

  return debounced;
}

export default debounce;
